import React from 'react';
import './BrySkeleton.css';

export const BrySkeleton = ({
  type = 'text', // text | title | avatar | custom
  width,
  height,
  className = '',
  style = {},
  count = 1,
}) => {
  const typeClass = type !== 'custom' ? `bry-skeleton-${type}` : '';
  const customStyle = {
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    ...style,
  };

  const skeletons = Array.from({ length: count });

  return (
    <>
      {skeletons.map((_, index) => (
        <div
          key={index}
          className={`bry-skeleton ${typeClass} ${className}`.trim()}
          style={customStyle}
        />
      ))}
    </>
  );
};
